const styles = {
  text: {
    paddingInline: 10
  }
};

export default styles;
